<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { deepCopy } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    checkValues:{
      type:Array,
      default: () => {
        return [];
      },
    },
    onChangeCheckValues:{
      type:Function,
    },
    submit:{
      type:Function,
    },
    cancel:{
      type:Function,
    },
});
const { identityId,checkValues } = toRefs(props);
const isLoading = ref(false);
const pharmacyTags = reactive([]);
const checkList = reactive([]);
for (let i=0;i<props.checkValues.length;i++) {
  checkList.push(props.checkValues[i]);
}
const onCheckChange = (event) => {
  if (event.target.checked == true) {
    checkList.push((isNaN(event.target.value) === true ? event.target.value : Number(event.target.value)));
  } else {
    for (let i=0;i<checkList.length;i++) {
      if (checkList[i] == event.target.value) {
        checkList.splice(i,1);
        break;
      }
    }
  }
  if (typeof props.onChangeCheckValues !== 'undefined') {
    props.onChangeCheckValues(deepCopy(checkList));
  }
}
const tagId = ref(0);
const tagName = ref('');
const backgroundColor = ref('#FFF');
const borderColor = ref('#000');
const color = ref('#000');
const getPharmacyTags = async () => {
  pharmacyTags.splice(0);
  isLoading.value = true;
  try {
    let params = {page_size:1000};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_tag_list,{params:params,paramsSerializer});
    for (let i=0;i<response.data.list.length;i++) {
      pharmacyTags.push(response.data.list[i]);
    }
  } finally {
    isLoading.value = false;
  }
}
watch(identityId,(newValue,oldValue) => {
  getPharmacyTags();
});
watch(checkValues,(newValue,oldValue) => {
  checkList.splice(0);
  for (let i=0;i<newValue.length;i++) {
    checkList.push(newValue[i]);
  }
},{deep:true});

onMounted(() => {
  //採用品の表示数だけ埋め込まれるのでここにAPI処理を入れないこと
})
onBeforeUnmount(() => {
})
const isTagEditDialog = ref(false);
const isTagEditDialogLoading = ref(false);
const showTagEditDialog = (tag) => {
  if (tag == null) {
    tagId.value = 0;
    tagName.value = '';
    backgroundColor.value = '#fff';
    borderColor.value = '#000';
    color.value = '#000';
  } else {
    tagId.value = tag.id;
    tagName.value = tag.tag_name;
    backgroundColor.value = tag.background_color;
    borderColor.value = tag.border_color;
    color.value = tag.color;
  }
  isTagEditDialog.value = true;
}
const closeTagEditDialog = () => {
  isTagEditDialog.value = false;
}
const updatePharmacyTag = async () => {
  isLoading.value = true;
  try {
    let params = {
      id:tagId.value,
      tag_name:tagName.value,
      background_color:backgroundColor.value,
      border_color:borderColor.value,
      color:color.value,
    };
    const response = await axios(props.apis.pharmacy_tag_update,{method:"post",data:params});
    if (response.data.status == 200) {
      let exists = false;
      for (let i=0;i<pharmacyTags.length;i++) {
        if (pharmacyTags[i].id == response.data.data.id) {
          exists = true;
          pharmacyTags[i].tag_name = response.data.data.tag_name;
          pharmacyTags[i].background_color = response.data.data.background_color;
          pharmacyTags[i].border_color = response.data.data.border_color;
          pharmacyTags[i].color = response.data.data.color;
          break;
        }
      }
      if (exists == false) {
        pharmacyTags.push(response.data.data);
      }
      if (typeof props.submit !== 'undefined') {
        props.submit(response.data.data);
      }
      closeTagEditDialog();
    }
  } finally {
    isLoading.value = false;
  }
}
const deletePharmacyTagConfirm = async (deleteTagId) => {
  let result = await confirmAlert('本当に削除しますか？');
  if (result.isConfirmed) {
    await deletePharmacyTag(deleteTagId);
  }
}
const deletePharmacyTag = async (deleteTagId) => {
  isLoading.value = true;
  try {
    let params = new FormData();
    params.append('id',deleteTagId);
    const response = await axios(props.apis.pharmacy_tag_delete,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        props.submit(response.data.data);
      }
    }
  } finally {
    isLoading.value = false;
  }

}
defineExpose({
  getPharmacyTags,
});
</script>

<style scoped>
li {
  padding:0.5rem;
  border-bottom:1px solid #ccc;
}
</style>
<template>
<div>
  <div v-show="isLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <div class="w-full">
    <div>
        <button type="button" @click="showTagEditDialog(null)" class="py-2 px-2 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-900 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"><i class="fa-solid fa-tag"></i> タグ追加</button>
    </div>
    <div class="overflow-y-auto overflow-x-hidden border border-solid border-gray-200'" style="width:100%;height:20vh;">
      <ul>
        <li v-for="pharmacyTag in pharmacyTags" :key="pharmacyTag.id" class="flex flex-row items-center justify-between">
          <div>
            <input type="checkbox" class="mr-2" v-model="checkList" @change="onCheckChange" :value="pharmacyTag.id">
            <span class="medicine-tag" :style="'background-color:' + pharmacyTag.background_color + ';border: 1px solid ' + pharmacyTag.border_color + ';color:' + pharmacyTag.color"><i class="fa-solid fa-tag"></i> {{ pharmacyTag.tag_name }}</span>
          </div>
          <div>
            <span @click="showTagEditDialog(pharmacyTag)" class="m-2 cursor-pointer"><i class="fa-solid fa-pen-to-square"></i></span>
            <span @click="deletePharmacyTagConfirm(pharmacyTag.id)" class="m-2 cursor-pointer"><i class="fa-solid fa-delete-left"></i></span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isTagEditDialog"
  width="30%"
  :is-loading="isTagEditDialogLoading"
  :close="closeTagEditDialog"
>
  <template v-slot:header>
    タグ編集
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <table class="w-full">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">タグ名 <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" v-model="tagName">
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">背景色 <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="color" v-model="backgroundColor">
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">枠線色 <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="color" v-model="borderColor">
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">文字色 <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="color" v-model="color">
        </td>
      </tr>
    </table>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updatePharmacyTag" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeTagEditDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

</template>

